import { NgModule } from "@angular/core";
import { AceEditorComponent } from "./component";
import { AceEditorDirective } from "./directive";
var list = [
    AceEditorComponent,
    AceEditorDirective
];
var AceEditorModule = (function () {
    function AceEditorModule() {
    }
    AceEditorModule.decorators = [
        { type: NgModule, args: [{
                    declarations: list.slice(),
                    imports: [],
                    providers: [],
                    exports: list
                },] },
    ];
    /** @nocollapse */
    AceEditorModule.ctorParameters = function () { return []; };
    return AceEditorModule;
}());
export { AceEditorModule };
//# sourceMappingURL=module.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-ace-editor/src/module.js
// module id = ./node_modules/ng2-ace-editor/src/module.js
// module chunks = vendor